import Drawer from '../../../../Components/Drawer';
import USDTGroup from '../../../../assets/images/withdrawal/withdraw-processing-usdt-icon.png';
import WithdrawShine from '../../../../assets/images/withdrawal/withdraw-shine.png';

type TWithdrawProcessModalProps = {
    open: boolean;
    onClose: () => void;
}

function WithdrawProcessModal({ onClose, open }: TWithdrawProcessModalProps) {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      side="bottom"
      closeStroke="gray-10"
      wrapperClassName="px-4 bg-withdrawModalBg rounded-t-[20px] overflow-hidden text-[white] relative"
    >
      <div
        className="
            font-Bangers
            flex flex-col items-center
        "
      >
        <div
          className="
            z-[1]
            flex flex-col items-center
            transform translate-y-[-10%]
          "
        >
          <img
            src={USDTGroup}
            alt="usdt-icon"
            className="
                transform translate-y-[10%]
                my-6
            "
          />
          <span className="text-[32px] leading-[27px]">Withdrawal Under Review</span>
          <span className="text-[18px] mt-1 withdrawal-gradient-text">
            We are currently reviewing your withdrawal
          </span>
          <span className="font-Inria text-xs max-w-[289px] mt-3 text-[#B5C4FC]">This usually takes a few minutes. You can close this window —You’ll be notified as soon as it’s approved or if anything needs your attention!</span>
        </div>
        <img
          src={WithdrawShine}
          alt="withdraw-shine"
          className="
            absolute
            inset-0
          "
        />
      </div>
    </Drawer>
  );
}

export default WithdrawProcessModal;
